<div class="row position-relative">
  <div class="col-lg-8 col-12">
    <div class="card flex-row">
      <div class="card-body">
        <ng-container *ngFor="let link of links; index as i; trackBy: trackByIndex">
          <hr *ngIf="i > 0" />
          <app-download-link [downloadLink]="link"></app-download-link>
        </ng-container>
      </div>
    </div>
  </div>
</div>




